import React, { useState } from 'react';
import {GoSearch} from 'react-icons/go';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';


const SearchBar = ({setCoord,width}) => {
  
  const [address,setAdress] = useState('')

 const  handleChange = address => {
   setAdress(address)
  };
 
 const  handleSelect = address => {
    geocodeByAddress(address)
    .then(results =>{ 
      getLatLng(results[0])
      console.log(results)
    })
    .then(({ lat, lng }) =>{
      console.log('Successfully got latitude and longitude', { lat, lng })
      setCoord({lat, lng})
      console.log(address)
    }
    );
  };

    return (
      <PlacesAutocomplete
        value={address}
        onChange={(e) => setAdress(e)}
        onSelect={()=>handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div 
          className='flex flex-row'
          >
            <div 
              className='flex flex-row bg-[#fff] p-[0.3rem] mt-[0.01rem] rounded-sm transition ease-in-out delay-100 text-[#333]'
            >
            <GoSearch 
            style = {{
              transition: 'all 1s ease-out,all 1s ease-out'
            }}
            className='transition ease-in-out delay-100 m-[.159rem] text-2xl'
            onClick={(e)=>{
              e.currentTarget.nextElementSibling.classList.remove('hidden')
              e.currentTarget.classList.remove('text-xl')
            }}
            />
            <input
              placeholder = 'Search Places ...'
              className = 'location-search-input outline-none bg-transparent p-2 placeholder-[#888] text-[#777] hidden'
              id = "search"
              onChange = { (e) =>{
                if(!e.currentTarget.value){
                  setTimeout(()=>{
                    e.target.classList.add("hidden")
                  },5000)
                }
              }}
            />
            </div>
          </div>
        )}
      </PlacesAutocomplete>
    );
}

export default SearchBar;